import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
    createOrEditIBCApi, 
    getEligibleSemenCollectionCertificatesApi 
} from "./internationalBreedingCertificateApi";

export const CreateOrEditIBCthunk = createAsyncThunk(
    "internationalBreedingCertificate/CreateOrEdit",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await createOrEditIBCApi(payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
            );
        }
    }
);

export const FetchEligibleSemenCollectionCertificatesthunk = createAsyncThunk(
    "internationalBreedingCertificate/GetEligibleSemenCollectionCertificates",
    async (ownerId, { rejectWithValue }) => {
        try {
            const response = await getEligibleSemenCollectionCertificatesApi(ownerId);
            const list = response?.data?.result || response?.data || [];
            return Array.isArray(list) ? list : [];
        } catch (error) {
            return rejectWithValue(
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
            );
        }
    }
);
